module.exports = __webpack_public_path__ + "img/Square_2.6438b0b7.jpg";